'use strict';

/**
 * @name Novicell Validate
 * @desc A script that inits validate.js with default Novicell settings
 * @author Bjørn Nyborg (BNY)
 * @example <form data-validate>
 * @requires https://github.com/cferdinandi/validate
 */


var novicell = novicell || {};

novicell.validate = novicell.validate || new function () {

    let form = document.querySelector('.form');

    this.init = function () {

        let requiredCheckboxes = document.querySelectorAll('.js-checkbox-group');
        for (let i = 0; i < requiredCheckboxes.length; i++) {
            const checkbox = requiredCheckboxes[i];
            checkbox.addEventListener('change', function() {
                let isChecked = false;
                for (let i = 0; i < requiredCheckboxes.length; i++) {
                    const checkedCheckbox = requiredCheckboxes[i];
                    if (checkedCheckbox.checked == true) {
                        isChecked = true;
                    }
                }
                for (let i = 0; i < requiredCheckboxes.length; i++) {
                    const checkedCheckboxInput = requiredCheckboxes[i];
                    if (isChecked) {
                        checkedCheckboxInput.removeAttribute('required');
                        if (checkedCheckboxInput.classList.contains('error')) {
                            checkedCheckboxInput.classList.remove('error');
                        }
                    } else {
                        checkedCheckboxInput.setAttribute('required', "");
                    }
                }
                
            }, false);
        }

        if (form) {

            validate.init({
                // Classes and Selectors
                selector: '[data-validate]',
                fieldClass: 'error',
                errorClass: 'error-message',

                // Messages
                messageValueMissing: form.getAttribute("data-error-msg-required"),
                messageValueMissingCheckbox: form.getAttribute("data-error-msg-checkbox"),
                messageValueMissingSelect: form.getAttribute("data-error-msg-select"),
                messageValueMissingRadio: form.getAttribute("data-error-msg-radio"),
                messageValueMissingSelectMulti: 'Vælg venligst mindst én værdi',
                messageTypeMismatchEmail: form.getAttribute("data-error-msg-required-email"),
                messageTypeMismatchURL: 'Indtast en gyldig URL',
                messageTooShort: 'Indtast venligst {minLength} karakterer eller mere. Du har indtastet {length} karakterer.',
                messageTooLong: 'Indtast venligst {maxLength} eller færre karakterer. Du har indtastet {length} karakterer.',
                messagePatternMismatch: 'Du har indtastet data i et forkert format',
                messageBadInput: 'Indtast venligst et tal',
                messageStepMismatch: 'Vælg venligst en gyldig værdi',
                messageRangeOverflow: 'Du må ikke angive mere end {max}.',
                messageRangeUnderflow: 'Du må ikke angive mindre end {min}.',
                messageGeneric: 'Den indtastede værdi er ugyldig',

                // Form Submission
                disableSubmit: false,
                onSubmit: function () {},
                
                // Callbacks
                beforeShowError: function (e) {
                    e.classList.add("validated");
                },
                afterShowError: function () {},
                beforeRemoveError: function () {},
                afterRemoveError: function () {},
            });
        }
    };
}();
